import React from 'react';
import theme from '@/styles/theme';
import { DefaultTheme } from 'styled-components';

export interface SVGIconType {
  width?: 16 | 24 | 32 | 64 | 21;
  height?: 16 | 24 | 32 | 64 | 15 | 10;
  color?: keyof DefaultTheme['color'];
  className?: string;
}

const FlagPtBrIcon = ({ width = 21, height = 15, color, ...props }: SVGIconType) => {
  const defaultColor = color ? theme.color[color] : 'black';
  return (
    <svg width={width} height={height} viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 0H19C19.5304 0 20.0391 0.210712 20.4142 0.585785C20.7893 0.960858 21 1.46957 21 2V13C21 13.5304 20.7893 14.0391 20.4142 14.4142C20.0391 14.7893 19.5304 15 19 15H2C1.46957 15 0.960858 14.7893 0.585785 14.4142C0.210712 14.0391 0 13.5304 0 13V2C0 1.46957 0.210712 0.960858 0.585785 0.585785C0.960858 0.210712 1.46957 0 2 0Z"
        fill="#24B47E"
      />
      <path d="M10.999 2L19.998 8.004L10.999 14.008L2 8.004L10.999 2Z" fill="#FCD669" />
      <path
        d="M7.05105 6.993C7.02167 7.16053 7.00462 7.32998 7.00004 7.5C6.99666 8.16944 7.18627 8.82567 7.54618 9.39014C7.90609 9.95461 8.42105 10.4034 9.02941 10.6828C9.63777 10.9622 10.3138 11.0603 10.9765 10.9655C11.6391 10.8706 12.2605 10.5868 12.766 10.148C11.3504 8.38485 9.29743 7.25116 7.05105 6.993ZM13.574 9.14C13.8497 8.63707 13.9961 8.07352 14 7.5C14.0022 6.72602 13.7469 5.97331 13.2743 5.36032C12.8018 4.74733 12.1388 4.30887 11.3898 4.11393C10.6407 3.919 9.84816 3.97867 9.13675 4.28354C8.42534 4.58841 7.83549 5.12118 7.46004 5.798C9.83721 6.12971 12.0114 7.31816 13.574 9.14Z"
        fill="#43458B"
      />
      <path
        d="M7.45975 5.798C7.25142 6.16785 7.1131 6.57297 7.05176 6.993C9.29742 7.25167 11.3505 8.38531 12.7658 10.148C13.0955 9.86521 13.3695 9.52336 13.5738 9.14C12.0111 7.31816 9.83692 6.12972 7.45975 5.798Z"
        fill="white"
      />
    </svg>
  );
};

export default FlagPtBrIcon;
